import MyRoutes from "./MyRoutes";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { SiteContentProvider } from "./context/SiteContentContext";

function App() {
  return (
    <SiteContentProvider>
      <div className="App">
        <Navbar />
        <MyRoutes />
        <Footer />
      </div>
    </SiteContentProvider>
  );
}

export default App;
